import { render, staticRenderFns } from "./ProjectSubmissionTable.vue?vue&type=template&id=92e1e590"
import script from "./ProjectSubmissionTable.vue?vue&type=script&lang=js"
export * from "./ProjectSubmissionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports